import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ReactiveFormsModule} from '@angular/forms';
import {LovValueUpdateComponent} from './lov-value-update.component';
import {CreateUpdateDefaultModule} from '../../../../../../core/component/create-update-default/create-update-default.module';
import {LoadingModule} from '../../../../../../../components/common/loading/loading.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ReactiveFormsModule,
        CreateUpdateDefaultModule,
        LoadingModule,
    ],
    declarations: [
        LovValueUpdateComponent,
    ],
    exports: [
        LovValueUpdateComponent,
    ]
})
export class LovValueUpdateModule {}
